<template>
  <el-card>
    <el-form>
      <el-form-item :label="`${$t('序号')}：`">
        <span>{{formData.num || ""}}</span>
      </el-form-item>
      <el-form-item :label="`${$t('姓名')}：`">
        <span>{{formData.username || ""}}</span>
      </el-form-item>
      <el-form-item :label="`${$t('手机号')}：`">
        <span>{{formData.phone || ""}}</span>
      </el-form-item>
      <el-form-item :label="`${$t('身份证号')}：`">
        <span>{{formData.idNum || ""}}</span>
      </el-form-item>
      <el-form-item :label="`${$t('证件有限期限')}：`">
        <span>{{formData.credTime}} ~ {{formData.credEndTime}}</span>
      </el-form-item>
      <el-form-item>
        <div class="phone-row">
          <div class="item">
            <preview-img width="280px" height="160px" :img-url="formData.idZhengPhoto || ''" />
            <span>{{ $t('身份证正面（国徽面）') }}</span>
          </div>
          <div class="item">
            <preview-img width="280px" height="160px" :img-url="formData.idFanPhoto" />
            <span>{{ $t('身份证反面') }}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="`${$t('情况说明')}：`">
        <span>{{formData.content || ""}}</span>
      </el-form-item>
      <template  v-if="formData.status !== 'toAudit'">
        <el-form-item :label="`${$t('审核意见')}：`">
          <dict-text :status="formData.status" dict-flag="AUTH_STATUS" ></dict-text>
        </el-form-item>
        <el-form-item :label="`${$t('审核备注')}：`">
          <span>{{formData.auditRemark || ""}}</span>
        </el-form-item>
      </template>
    </el-form>
  </el-card>
</template>

<script>
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import DictText from "@/components/dict/DictText.vue";

export default {
  name: "AuthDetail",
  components: {DictText, PreviewImg},
  data() {
    return {
      formData: { },
    }
  },
  methods: {
    async loadDetail() {
      try {
        const res = await request(this.$api.userAuth.detail, this.$route.query);
        this.formData = res.userAuth;
        this.formData.credTime = this.$moment(this.formData.credTime).format("YYYY-MM-DD");
        this.formData.credEndTime = this.$moment(this.formData.credEndTime).format("YYYY-MM-DD");
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>
.el-form {
  width: 600px;
}

.phone-row {
  display: flex;
  align-items: center;
  column-gap: 16px;
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 12px;
}

</style>
